import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import AccessDeniedPage from '../pages/AccessDeniedPage';
import GlobalLoader from '../components/GlobalLoader';

function PermissionRoute({
    children,
    permission,
    permissions = [],
    requireReactAccess = true,
    allPermissions = [],
    anyPermissions = [],
    internalOnly = false,
}) {
    const location = useLocation();
    const { user, isAuthenticated, can, canAny, status, isAuthRefreshing } = useAuth();

    if (status === 'loading' || isAuthRefreshing) {
        return <GlobalLoader message="Validando sesión y permisos..." minHeight="70vh" />;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (requireReactAccess && !can('access.react_tecnicos')) {
        return (
            <AccessDeniedPage
                title="Acceso a app tecnica no habilitado"
                description="Tu usuario no tiene habilitado access.react_tecnicos."
            />
        );
    }

    const hasRequiredPermission = permission
        ? can(permission)
        : (permissions.length > 0 ? canAny(permissions) : true);

    const internal = !internalOnly || !['cliente', 'sucursal'].includes(user?.tipo_acceso || user?.role?.tipo_acceso);
    if (!hasRequiredPermission || !allPermissions.every(can) || (anyPermissions.length > 0 && !canAny(anyPermissions)) || !internal) {
        return (
            <AccessDeniedPage
                title="Permiso insuficiente"
                description="Tu cuenta no tiene habilitada esta sección. Consultá al responsable de tu empresa."
            />
        );
    }

    return children;
}

export default PermissionRoute;
